import axios from 'axios';
import qs from 'qs';
import { CookieStorage } from '@dustess/itimo-core';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var cancelCode = 'cancel.code';
var CancelToken = axios.CancelToken;
var AjaxPromise = /*#__PURE__*/function (_Promise) {
  _inheritsLoose(AjaxPromise, _Promise);

  function AjaxPromise(executor) {
    var _this;

    var canceled = false;

    var resolve = function resolve(_) {},
        reject = function reject(_) {};

    _this = _Promise.call(this, function (_resolve, _reject) {
      resolve = _resolve;
      reject = _reject;
    }) || this;
    executor.call(_assertThisInitialized(_this), function (canceler) {
      _this.canceler = function () {
        canceled = true;
        canceler(cancelCode);
      };
    }, function (res) {
      if (canceled) reject(res);
      resolve(res);
    }, reject);
    return _this;
  }

  var _proto = AjaxPromise.prototype;

  _proto.canceler = function canceler() {};

  _proto.abort = function abort() {
    this.canceler();
  };

  return AjaxPromise;
}( /*#__PURE__*/_wrapNativeSuper(Promise));

/*
 * @Descripttion:
 * @Date: 2020-03-16 11:05:26
 * @LastEditors: xiaokun
 * @LastEditTime: 2024-08-20 18:04:09
 */
var ErrorCode = {
  601: '无空闲小号',
  602: '调用接口错误',
  603: '发起呼叫接口调用异常',
  605: '当前平台信息未配置',
  606: '当前平台未启用',
  607: '企业尚未配置当前呼叫平台',
  608: '企业尚未能开启当前呼叫方式',
  609: '呼叫配置解析错误',
  610: '操作太频繁了，请稍后再试',
  700: '无效的脚本',
  701: '无效的映射值',
  4000: '您的当前访问出现问题，请联系管理员',
  4001: '无效session',
  4005: '参数解析错误：一般是参数校验失败或者序列化失败',
  4008: '没有可导出的数据',
  4009: '号码解密失败',
  4051: '无公海管理权限，请联系管理员',
  4100: '联系人不存在',
  4101: '联系人名称过长',
  4102: '联系人企业名称过长',
  4103: '联系人职务名称过长',
  4104: '联系人地址名称过长',
  4105: '联系人邮箱名称过长',
  4106: '联系人描述过长',
  4107: '联系人号码过多',
  4108: '合并联系人数据失败',
  4109: '获取联系人操作日志失败',
  4110: '合并联系人跟进记录失败',
  4115: '联系人列表表头获取失败',
  4116: '联系人列表表头更新失败',
  4117: '联系人公司模板字段获取失败',
  4118: '联系人公司模板字段更新失败',
  4119: '联系人公司信息获取失败',
  4120: '联系人公司信息更新失败',
  4121: '联系人公司信息新增失败',
  4122: '联系人公司信息列表获取失败',
  4123: '联系人号码重复',
  4200: '订单不存在',
  4124: '联系人公司操作日志获取错误',
  4125: '联系人公司下联系人列表获取错误',
  4126: '新增联系人失败',
  4127: '联系人分配多员工失败',
  4128: '联系人更新失败',
  4129: '该线索已被领取',
  4131: '公司下有联系人不允许删除',
  4132: '简称重复，无法提交',
  4130: '全称重复，无法提交',
  4136: '请关联该企业工商信息',
  4201: '商品类别达到最大限制',
  4202: '订单名字过长',
  4203: '订单备注过长',
  4206: '销售机会阶段正被使用',
  4300: '部门列表获取失败',
  4350: '成员列表获取失败',
  4351: '获取会话内容存档开启成员列表失败',
  4352: '成员联系人数和线索数获取失败',
  4353: '成员角色获取失败',
  4500: '联系人公海获取失败',
  4502: '联系人公海数量达到上线',
  4504: '公海为回收目标公海，不可删除',
  4600: '回收站联系人获取失败',
  4602: '回收联系人删除操作无效',
  4603: '回收站删除联系人失败',
  4700: '企业标签获取失败',
  4800: '联系人模板获取失败',
  4801: '联系人模板添加失败',
  4802: '联系人模板更新失败',
  4820: '联系人无效原因数量超出限制',
  4821: '联系人无效原因字数超出限制',
  4822: '联系人无效原因添加失败',
  4823: '联系人无效原因获取失败',
  4824: '联系人无效原因更新失败',
  4840: '联系人跟进状态获取失败',
  4841: '联系人跟进状态添加失败',
  4842: '联系人跟进状态更新失败',
  4843: '跟进状态数量已达最大限制',
  4860: '联系人来源获取失败',
  4861: '联系人来源解析失败',
  4862: '联系人来源名称错误',
  4863: '联系人来源名称重复',
  4864: '联系人来源已达最大限制',
  4865: '联系人来源新增失败',
  4866: '联系人来源更新失败',
  4867: '联系人来源删除失败',
  5001: '角色添加失败',
  5002: '角色编辑失败',
  5003: '角色获取失败',
  5004: '角色删除失败',
  5005: '角色配置权限失败',
  5006: '获取角色列表失败',
  5007: '获取角色权限树出错',
  5200: '没有菜单权限，请联系管理员',
  5201: '没有功能权限，请联系管理员',
  5202: '没有数据权限，请联系管理员',
  5203: '权限校验参数错误',
  5204: '权限校验参数错误 商品错误',
  5400: '商品状态错误',
  5401: '商品名称过长',
  5402: '商品描述过长',
  5403: '商品已被关联，无法删除',
  5404: '商品类型已被关联，无法删除',
  5405: '商品类型重复',
  6001: '上传excel出错',
  6002: '上传excel文件名后缀出错',
  // 敏感行为部分
  6010: '获取全部敏感行为出错',
  6011: '获取敏感行为监控设置出错',
  6012: '设置监控敏感行为出错',
  6013: '添加敏感词出错',
  6014: '添加的敏感词重复',
  6015: '修改敏感词出错',
  6016: '敏感词已存在',
  6017: '删除敏感词出错',
  6018: '获取敏感词列表出错',
  6019: '获取敏感行为通知出错',
  6020: '敏感行为通知开关出错',
  6021: '更新敏感行为通知出错',
  6022: '获取敏感行为列表出错',
  6023: '处理敏感行为出错',
  6024: '导出敏感行为出错',
  6025: '单次新增敏感词超过50个',
  6026: '该分类中敏感词个数超过500个',
  6027: '敏感词不能超过12个字',
  6028: '添加的敏感词全部失败',
  6050: '统计暂无数据',
  6051: '没有可下载的录音',
  // 公众号授权
  7001: '请先完成公众号授权，在使用该功能',
  7002: '数据清理暂未完成，请稍后再试',
  // 名片管理
  500110: '最多只能设置 5 个默认名片, 不能超过 5 个！',
  500111: '必须要有 1 个默认名片，不能全部关闭！',
  8000: '设备已登出',
  8001: '当前员工未使用电销手机',
  8002: '设备不在线',
  8003: '达到呼叫上限',
  9001: '标签类型必须是业务标签',
  9002: '标签组名称长度不正确',
  9003: '标签组名重复',
  9004: '标签数量超限',
  9005: '标签名长度不正确',
  9006: '组内标签名重复',
  9007: '部门标签组数量超限',
  9300: '签到备注信息过长',
  9301: '关联联系人为空',
  9302: '关联联系人不存在',
  9303: '抄送人不存在',
  9304: '不是联系人跟进人，无权限签到',
  11000: '读取订单配置错误',
  11001: '获取审核人员错误',
  11002: '订单审核人员为空',
  11003: '获取发货人员错误',
  11004: '订单发货人员为空',
  11005: '获取退货审批人员错误',
  11006: '订单退货审批人员为空',
  11007: '获取当前用户错误',
  11008: '订单查询错误',
  11009: '订单更新错误',
  11010: '订单已删除',
  11011: '订单状态已变化，请刷新页面查看',
  11012: '订单没有操作权限',
  11020: '新增订单商品为空',
  11021: '新增订单商品重复',
  11022: '新增订单商品不存在（也可能是部分商品不存在）',
  11023: '新增订单凭证为空',
  11024: '新增订单手机错误',
  11025: '新增订单创建快照错误',
  11026: '新增订单获取收货地址错误',
  11027: '新增订单没有选择收货地址',
  11028: '新增订单收货地址省市区错误',
  11029: '新增订单新增收货地址错误',
  11030: '新增订单写入错误',
  11031: '订单列出查询条件错误',
  11032: '订单列出统计订单总数错误',
  11033: '列出订单查询订单错误',
  11035: '列出订单绑定订单外的信息错误',
  11036: '导出订单列表错误',
  11037: '导出订单列表为空',
  11040: '订单审核查询不到部分商品',
  11050: '删除订单数据发生错误',
  11051: '删除订单关联数据错误',
  11052: '删除订单关联数据错误',
  11100: '订单设置更新错误',
  11101: '财务审核人为空，已选角色/部门下无人',
  11102: '发货人为空，已选角色/部门下无人',
  11103: '退货审核人为空，已选角色/部门下无人',
  11120: '获取订单来源失败',
  11121: '订单来源数量超过最大限制',
  11122: '订单来源名称长度错误',
  11123: '单个来源店铺数量超过最大限制',
  11124: '订单来源名称重复',
  11125: '来源店铺名称长度错误',
  11126: '来源店铺名称重复',
  11127: '订单来源更新错误',
  11200: '查询售后订单错误',
  11201: '统计售后订单错误',
  11202: '创建售后订单错误',
  11203: '更新售后订单错误',
  11204: '售后单已删除',
  11205: '售后单凭证数量过多',
  11206: '售后单退款方式错误',
  11207: '订单状态已变化，请刷新页面查看',
  11208: '售后订单没有操作权限',
  11220: '售后订单查询条件错误',
  11221: '售后订单列表查询错误',
  11222: '售后订单绑定信息错误',
  11223: '售后订单列表导出错误',
  11224: '售后订单列表导出为空',
  11400: '目标模板不存在或已删除',
  11401: '目标模板名称为空',
  11402: '目标模板数量超过10000',
  11403: '目标模板类型错误',
  11404: '目标模板周期错误',
  11405: '模板考核目标错误',
  11406: '模板考核对象错误',
  11407: '目标不存在或已删除',
  11408: '目标数不匹配周期',
  11409: '目标用户已经存在',
  12001: '外呼配置为空',
  12002: '第三方外呼功能已关闭',
  12003: '获取账户外呼配置出错',
  12004: '开/关账户外呼配置出错',
  12005: '修改账户外呼配置出错',
  12006: '批量开启关闭员工第三方外呼出错',
  12007: '开启关闭员工第三方外呼出错',
  12008: '修改员工外呼配置出错',
  12009: '获取员工外呼配置出错',
  13001: '提醒时间不能小于当前时间',
  13008: '公海 ID 为空',
  13009: '时间字段全部为0',
  // B端联系人
  24100: '联系人不存在',
  24115: '联系人列表表头获取失败',
  24116: '户列表表头更新失败',
  24117: '联系人公司模板字段获取失败',
  24127: '联系人分配多员工失败',
  24129: '联系人已被领取',
  24131: '删除失败，删除前需先取消关联所有联系人',
  24132: '部分联系人删除失败，删除前需先取消关联所有联系人',
  24133: '联系人名重复',
  24134: '联系人字段校验不通过',
  24135: '联系人名称不能为空',
  24610: '回收站还原联系人失败, 联系人名已存在',
  11300: '销售汇报不存在或已删除',
  11301: '销售汇报评论不存在或已删除',
  // 发票回款
  13100: '该线上回款期次已经完全回款不能删除',
  13101: '该计划回款总金额大于该订单未回款金额',
  11053: '新增订单凭证或回款单为空',
  11054: '新增订单支付方式为空',
  11128: '订单来源不能为空',
  13102: '计划回款期次数量超出限制',
  13103: '该订单已回款',
  13104: '该回款计划期次正在支付，请勿重复支付',
  13105: '该回款期次不存在',
  13106: '该回款计划期次已回款',
  13107: '订单已修改, 请刷新页面',
  13108: '未配置银联配置',
  13109: '线上订单已关联了金额的回款计划不能删除',
  11231: '订单在支付中，不能操作',
  11230: '商品查找错误，无效的商品Id',
  14001: '无效的回款单号',
  14002: '回款单单页数据量大于1000',
  14003: 'PcAddOrder操作必须有cusId',
  14004: '回款单id为空',
  14005: '订单id和cusId不能都为空',
  14006: '关联的订单金额大于回款单金额',
  14007: '系统创建单回款单不可修改',
  14008: '存在本次回款金额大于本期计划回款金额的关联订单',
  11501: '发票不存在',
  11502: '没有发票审核权限，请联系管理员',
  // 后端出错code
  500500: '您的当前访问出现问题，请联系管理员',
  20001: '未开启定位，请前往设置页面启用',
  20002: '无法导出，暂只支持1000条内的数据导出',
  // 活码code
  50011005: '企业微信api调用失败',
  // 红包模块
  50004012: '基础配置信息错误',
  50004010: '有员工已存在，不能重复添加',
  50004022: '部门员工为空，请重新选择',
  // 话术库
  50009006: '关键词名称已存在',
  50009007: '商品标签名称已存在',
  50009008: '关键词或商品标签名称不存在',
  50009009: '目录父节点不存在，请刷新页面后重试',
  50009010: '问题名称已重复',
  50009011: '修改的问题不存在，请刷新页面后重试',
  50009012: '常用语已经存在',
  50009013: '百问百答问题已经存在',
  50009014: '请上传5MB以内的文件',
  50009015: '请上传XLSX类型文件',
  50009016: '上传文件校验失败',
  // 企业动态
  50007001: '未找到企业动态',
  50007002: '参数校验失败',
  50007003: '标题过长',
  50007004: '文本过长',
  50007005: '图片张数过多',
  50007006: '标题不能为空',
  50007007: '查询企微部门下的成员列表错误',
  50007008: '查询企微成员列表错误',
  50007009: '用户未开通企业动态或不允许发布',
  50007010: '不能修改他人动态',
  50007011: '企业id无效',
  // 商户号授权
  50004024: '公众号查询异常',
  5001400: '未找到公司信息',
  5001401: 'sceneId 无效',
  5001402: '参数缺少商品id',
  5001403: '找不到商城个人信息，请先开通小程序',
  5001404: '商品分类未找到',
  5001405: '该分类已被绑定，无法删除',
  5001406: '分类删除出错',
  // 商城管理
  50017027: '规格值重复',
  50012031: '商品信息未找到或者商品已被下架',
  50017034: '已上架的商品不能编辑',
  50017035: '商品编码不能重复',
  50012001: '价格小数位只能为两位',
  5001414: '关联活动不能修改',
  50012002: '商品价格信息有误',
  50012004: '商品信息有误',
  50012054: '订单来源未找到',
  50012061: '要查找的来源店铺不存在',
  50012065: '请上传订单凭证',
  50012066: '不能创建订单金额为0的订单',
  50012003: '折扣小数位只能为两位',
  50012005: '当前订单状态不能修改价格',
  50012006: '订单不存在',
  50012007: '无可用剩余单量',
  50012086: '员工信息未找到',
  50012085: '未找到对应联系人',
  50012084: '订单审核设置配置有误',
  50012083: '未找到管理员信息',
  50012049: '自定义字段信息有误',
  50012071: '当前订单状态有误，请等待状态流转',
  50012060: '反序列化时出错',
  50012051: '线上支付订单实付总价不能为0',
  50012043: '没有可供操作的订单，或订单状态有误',
  50012041: '订单支付金额有误',
  50012040: '支付配置有误',
  50012036: '用户信息有误',
  50012035: '数据不可用',
  50012024: '会员信息有误',
  50012023: '订单信息有误',
  50012022: '库存不足',
  50012017: '商品活动信息有误',
  50012015: '用户地址信息有误',
  50012014: '当前订单状态不能被更新',
  50012067: '计划回款总金额大于该订单未回款金额',
  50012068: '金额为0的线下订单不能转成线上',
  50012069: '订单状态不能被编辑',
  50012070: '获取回款计划错误',
  50012013: '数据不存在',
  50012016: '优惠券信息有误',
  50012019: '公司信息有误',
  50012074: '库存扣除异常',
  // 1.2.5版本错误码
  // 运营中心版本错误码商城通用设置-获取订单信息设置
  20022: '分组（分类）数量已达上限',
  20023: '分组（分类）名重复了',
  20024: '素材库名称重复',
  20025: '同步营销素材报表太频繁',
  20026: '分组（分类）不存在',
  20027: '员工不存在',
  20028: '分组（分类）深度已达上限',
  20029: '找不到素材库',
  20030: '没有删除权限，请联系管理员',
  50017014: '关联活动不能修改',
  // 集云卡号
  4905: '集云卡主号不存在',
  // 小号外呼新增
  12010: '小号不能为空',
  12011: '修改小号出错',
  12012: '已经存在绑定关系，不能重复拨号',
  12013: '没有可用的小号',
  12014: '第三方绑定出错',
  12015: '绑定小号通话失败',
  12016: '小号外呼配置为空',
  12017: '小号外呼功能已关闭',
  // 群sop
  20004: '找不到群SOP数据',
  20005: '找不到群SOP触发条件数据',
  20006: 'sop子任务节点数据丢失',
  20007: 'sop数据丢失',
  20008: 'sop节点数超过系统上限',
  20009: '找不到群sop',
  20010: '数据库发生异常，请稍后重试',
  20011: '此sop数据已变更，请刷新后重试',
  20012: '更新sop节点定时器失败',
  20013: 'sop名称重复',
  // 美莱三期优化新增
  50019001: '找不到销售sop员工任务',
  50019002: '重复撤回销售sop员工任务',
  50018002: '找不到员工任务数据',
  50018003: '当前任务状态无法撤回',
  50018004: '重复撤回任务',
  // 跟进提醒
  16000: '跟进计划不存在',
  16001: '跟进计划查询时间不能超过三个月',
  10006: '请勿频繁操作，前往下载中心下载',
  // scrm1.0.9 code与运营中心保持同步
  50020001: '对不起，素材已被删除',
  90001010: '审核出错,请刷新页面再试一次',
  // crm 常用筛选
  20030053: '名称已存在',
  20030054: '常用筛选项已达上限'
};
var HttpCode = {
  401: '登录失效，请重新登录',
  404: '请求的数据接口不存在！',
  408: '请求超时',
  500: '您的当前访问出现问题，请联系管理员',
  10001: '未知错误！',
  10002: '网络错误，请检查网络是否正常！'
};
function injectErrorCode(codeMap) {
  Object.assign(ErrorCode, codeMap);
}
function useErrorCode() {
  var errorCode = _extends({}, ErrorCode);

  var httpCode = _extends({}, HttpCode);

  function setErrorCode(data) {
    Object.assign(errorCode, data);
  }

  function setHttpCode(data) {
    Object.assign(httpCode, data);
  }

  return {
    errorCode: errorCode,
    httpCode: httpCode,
    injectErrorCode: setErrorCode,
    injectHttpCode: setHttpCode
  };
}

/**默认toast防抖配置 */
var ToastConfig = {
  toastDelay: 0
};

function setToastConfig(config) {
  AxiosConfig.toastDebounce = config;
}

function setActiveRule(rules) {
  AxiosConfig.rules = rules;
}

var AxiosConfig = {
  toastDebounce: ToastConfig
};
var Config = {
  setToastConfig: setToastConfig,
  setActiveRule: setActiveRule,
  AxiosConfig: AxiosConfig
};

var HostConfig = {
  dev: {
    SETTING: 'https://mk-test.dustess.com'
  },
  master: {
    SETTING: 'https://mk-test.dustess.com'
  },
  qa: {
    SETTING: 'https://mk-qa.dustess.net'
  },
  release: {
    SETTING: 'https://global.dustess.com'
  },
  tencent: {
    SETTING: 'https://global-tx.dustess.com'
  }
};
function setHostConfig(config) {
  if (!config) {
    return;
  }

  Object.keys(config).forEach(function (key) {
    var envKey = key;
    Object.assign(HostConfig[envKey], config[envKey]);
  });
}
var webGatewayEnv = {
  dev: 'dev',
  dev2: 'dev2',
  dev3: 'dev3',
  dev4: 'dev4',
  master: 'test',
  master2: 'test2',
  master3: 'test3',
  master4: 'test4',
  qa: 'qa',
  release: '',
  tencent: 'tx'
};
/**
 * 研发环境：mk-api-dev.dustess.com、mk-api-dev2.dustess.com、mk-api-dev3.dustess.com、mk-api-dev4.dustess.com
 * 测试环境：mk-api-test.dustess.com、mk-api-test2.dustess.com、mk-api-test3.dustess.com、mk-api-test4.dustess.com
 * qa：api-qa.dustess.net
 * 阿里云：api.dustess.com
 * 腾讯云：api-tx.dustess.com
 */

var getWebGatewayHost = function getWebGatewayHost() {
  // 兼容私有云的webGateWay
  var host = getEnvWebGateWayHost();

  if (host) {
    return host;
  }

  var config = getConfigEnv();
  if (!config) return undefined;
  var subDomain = 'mk-api';
  var env = webGatewayEnv[config];

  switch (env) {
    case '':
      // release
      subDomain = 'api';
      break;

    case 'tx': // tencent

    case 'qa':
      // qa
      subDomain = "api-" + env;
      break;

    default:
      subDomain = subDomain + "-" + env;
  }

  var suffix = env === 'qa' ? 'net' : 'com';
  return "https://" + subDomain + ".dustess." + suffix;
};

function getConfigEnv() {
  var _window$envConfig;

  return (_window$envConfig = window.envConfig) == null ? void 0 : _window$envConfig.VUE_APP_MKCONFIG_ENV;
}

function getEnvWebGateWayHost() {
  var _window$envConfig2;

  return (_window$envConfig2 = window.envConfig) == null ? void 0 : _window$envConfig2.VUE_APP_WEBGATEWAY_BASE_URL;
}
/**获取配置中心的域名 */


function getEnvConfigCenterHost() {
  var _window$envConfig3;

  return (_window$envConfig3 = window.envConfig) == null ? void 0 : _window$envConfig3.VUE_APP_CONFIG_CENTER_BASE_URL;
}

function getEnvKey() {
  var config = getConfigEnv();

  if (!config) {
    return undefined;
  }

  if (config.includes('dev')) {
    return 'dev';
  }

  if (config.includes('master')) {
    return 'master';
  }

  return config;
}

function getHost(key) {
  if (key === void 0) {
    key = 'SETTING';
  }

  // 私有云租户，会走这个逻辑
  var configUrl = getEnvConfigCenterHost();
  if (configUrl) return configUrl;
  var env = getEnvKey();

  if (env) {
    var _HostConfig$env;

    return ((_HostConfig$env = HostConfig[env]) == null ? void 0 : _HostConfig$env[key]) || '';
  }

  return '';
}
function useHostConfig() {
  var hostConfig = _extends({}, HostConfig);

  function injectHostConfig(config) {
    if (!config) {
      return;
    }

    Object.keys(config).forEach(function (key) {
      var envKey = key;
      Object.assign(hostConfig[envKey], config[envKey]);
    });
  }

  function getHostByName(key) {
    if (key === void 0) {
      key = 'SETTING';
    }

    // 私有云租户，会走这个逻辑
    var configUrl = getEnvConfigCenterHost();
    if (configUrl) return configUrl;
    var env = getEnvKey();

    if (env) {
      var _hostConfig$env;

      return ((_hostConfig$env = hostConfig[env]) == null ? void 0 : _hostConfig$env[key]) || '';
    }

    return '';
  }

  return {
    injectHostConfig: injectHostConfig,
    getHostByName: getHostByName
  };
}

var AxiosConfig$1 = Config.AxiosConfig;
var ResponseInterceptorsList = [];
var RequestInterceptorsList = [];
var ToastInterceptorsList = [];

var insertInterceptorsFactory = function insertInterceptorsFactory(list, interceptorTranslator) {
  interceptorTranslator = typeof interceptorTranslator === 'function' ? interceptorTranslator : function (interceptor) {
    return interceptor;
  };
  return function (name, interceptor, index) {
    if (index === void 0) {
      index = -1;
    }

    var insertIndex = typeof index === 'function' ? index(list) : index;
    var insertInterceptor = interceptorTranslator(interceptor);

    if (insertIndex === undefined) {
      list.push({
        name: name,
        interceptor: insertInterceptor
      });
    } else {
      list.splice(insertIndex, 0, {
        name: name,
        interceptor: insertInterceptor
      });
    }

    return function () {
      var index = list.findIndex(function (interceptor) {
        return interceptor.name === name;
      });
      list.splice(index, 1);
    };
  };
};

var queueExecutor = function queueExecutor(list) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return list.some(function (executor) {
    return executor.interceptor.apply(executor, args);
  });
};

function isMatchUrl(matcher, url) {
  if (typeof matcher === 'function') {
    return matcher(url || '');
  }

  return url == null ? void 0 : url.match(matcher);
}

function applyRules(response) {
  var _AxiosConfig$rules = AxiosConfig$1.rules,
      rules = _AxiosConfig$rules === void 0 ? [] : _AxiosConfig$rules;

  if (!(rules != null && rules.length)) {
    return false;
  }

  var config = response.config,
      data = response.data;
  return rules.some(function (rule) {
    var matcher = rule.matcher,
        message = rule.message,
        checkSuccess = rule.checkSuccess;

    if (isMatchUrl(matcher, config.url)) {
      if (checkSuccess(data)) {
        return true;
      }

      var msg = message(data);
      msg && axiosToast(msg);
      return true;
    }

    return false;
  });
}

var defaultResponseInterceptor = function defaultResponseInterceptor(response) {
  // 如果隐藏toast，则直接return
  if (response.config.hideToast) {
    return;
  }

  var _response$data = response.data,
      _response$data$succes = _response$data.success,
      success = _response$data$succes === void 0 ? true : _response$data$succes,
      _response$data$code = _response$data.code,
      code = _response$data$code === void 0 ? '' : _response$data$code,
      msg = _response$data.msg;

  if (applyRules(response)) {
    return;
  }

  var mapCode = ErrorCode[code]; // 新的错误处理方式为，只要后端不报错，都返回true
  // 前端进行提示以及操作

  if (success) {
    // 如果在errorCode中定义了code，则直接进行提示
    if (mapCode) {
      axiosToast(mapCode);
    }
  } else {
    // const mapCode: string = ErrorCode[code]
    // 兼容老的错误提示方式，保留此段代码
    // 老的错误处理方式为后端返回false，并且返回code，前端进行错误提示
    if (code) {
      var codeMsg = mapCode || msg;
      axiosToast(codeMsg);
    } else {
      axiosToast(msg);
    }
  }
};

var showToast = null;

function debounce(func, delay) {
  var lastTime = 0;
  return function () {
    var now = Date.now();

    if (now - lastTime > delay) {
      lastTime = now;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      func(args);
      return;
    }

    lastTime = now;
  };
}

function removeDuplicates(list) {
  var map = new Map();
  list.forEach(function (item) {
    // 使用 name 和 func.toString() 的组合作为唯一键
    var key = item.name + "-" + item.interceptor.toString();

    if (!map.has(key)) {
      map.set(key, item);
    }
  }); // 返回去重后的数组

  return Array.from(map.values());
}

var axiosToast = function axiosToast(message, hideToast) {
  if (hideToast === void 0) {
    hideToast = false;
  }

  if (hideToast) return;
  var toastDebounce = AxiosConfig$1.toastDebounce; // 过滤相同的name和func的Toast，避免重复弹出message

  var noDuplicateToastInterceptorsList = removeDuplicates(ToastInterceptorsList);

  if (typeof toastDebounce === 'object' && toastDebounce.toastDelay) {
    var toastDelay = toastDebounce.toastDelay;

    if (!showToast) {
      showToast = debounce(function () {
        queueExecutor(noDuplicateToastInterceptorsList, message);
      }, toastDelay);
    }

    showToast();
    return;
  }

  queueExecutor(noDuplicateToastInterceptorsList, message);
};
var interceptorsRequest = /*#__PURE__*/insertInterceptorsFactory(RequestInterceptorsList);
var interceptorsResponse = /*#__PURE__*/insertInterceptorsFactory(ResponseInterceptorsList);
var interceptorsToast = /*#__PURE__*/insertInterceptorsFactory(ToastInterceptorsList, function (toast) {
  return function (message) {
    if (message) {
      toast.error(message);
    }
  };
});
var initAxios = function initAxios(inst) {
  inst.interceptors.request.use(function (config) {
    queueExecutor(RequestInterceptorsList, config);
    return config;
  });
  inst.interceptors.response.use(function (config) {
    // 2xx 开头的处理
    if (!queueExecutor(ResponseInterceptorsList, config)) {
      defaultResponseInterceptor(config);
    }

    return config;
  }, function (error) {
    // 非 2xx
    var response = error.response || {};

    if (!queueExecutor(ResponseInterceptorsList, response)) {
      defaultResponseInterceptor(response);
    }

    return Promise.reject(error);
  });
};

/** mock 地址 */
var originMockUrl = // 'http://127.0.0.1:7001/duerox-workbench-api/web_api_mock/mockDataForUser';
'https://duerox.dustess.com/duerox-workbench-api/web_api_mock/mockDataForUser';
var localMockUrl = 'http://127.0.0.1:7001/imock';

var getMockUrl = function getMockUrl(optionName, config) {
  var _mockOption$localOpti, _mockOption$remoteOpt;

  var _config$mock = config.mock,
      mock = _config$mock === void 0 ? false : _config$mock,
      getMockMethod = config.getMockMethod,
      _config$mockOption = config.mockOption,
      mockOption = _config$mockOption === void 0 ? {
    localOptionName: [],
    remoteOptionName: []
  } : _config$mockOption;
  if (!(process.env.NODE_ENV === 'development' && mock)) return '';
  var isInLocalOption = mockOption == null ? void 0 : (_mockOption$localOpti = mockOption.localOptionName) == null ? void 0 : _mockOption$localOpti.includes(optionName);
  var isInRemoteOption = mockOption == null ? void 0 : (_mockOption$remoteOpt = mockOption.remoteOptionName) == null ? void 0 : _mockOption$remoteOpt.includes(optionName);
  /** getMockMethod 说明：
   * allMockFromRemote：全部接口走远程 mock
   * allMockFromLocal：全部接口走本地 mock
   * allMockBasisLocalAPI：mockOption 下的 localOptionName 中包含的接口走本地 mock，其余接口走远程 mock
   * allMockBasisRemoteAPI：mockOption 下的 remoteOptionName 中包含的接口走远程 mock，其余接口走本地 mock
   * partMock：mockOption 下的 localOptionName 中包含的接口走本地 mock，partMock 下的 remoteOptionName 中包含的接口走远程 mock，其余接口走真实接口
   */

  switch (getMockMethod) {
    case 'allMockFromRemote':
      return originMockUrl;

    case 'allMockFromLocal':
      return localMockUrl;

    case 'allMockBasisLocalAPI':
      return isInLocalOption ? localMockUrl : originMockUrl;

    case 'allMockBasisRemoteAPI':
      return isInRemoteOption ? originMockUrl : localMockUrl;

    case 'partMock':
      if (isInLocalOption) return localMockUrl;
      if (isInRemoteOption) return originMockUrl;
      return '';

    default:
      return '';
  }
};

function useInterceptors(inst, config, codeMap) {
  var ResponseInterceptorsList = [];
  var RequestInterceptorsList = [];
  var ToastInterceptorsList = [];
  var AxiosConfig = config.AxiosConfig;

  var insertInterceptorsFactory = function insertInterceptorsFactory(list, interceptorTranslator) {
    interceptorTranslator = typeof interceptorTranslator === 'function' ? interceptorTranslator : function (interceptor) {
      return interceptor;
    };
    return function (name, interceptor, index) {
      if (index === void 0) {
        index = -1;
      }

      var insertIndex = typeof index === 'function' ? index(list) : index;
      var insertInterceptor = interceptorTranslator(interceptor);

      if (insertIndex === undefined) {
        list.push({
          name: name,
          interceptor: insertInterceptor
        });
      } else {
        list.splice(insertIndex, 0, {
          name: name,
          interceptor: insertInterceptor
        });
      }

      return function () {
        var index = list.findIndex(function (interceptor) {
          return interceptor.name === name;
        });
        list.splice(index, 1);
      };
    };
  };

  var queueExecutor = function queueExecutor(list) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return list.some(function (executor) {
      return executor.interceptor.apply(executor, args);
    });
  };

  function isMatchUrl(matcher, url) {
    if (typeof matcher === 'function') {
      return matcher(url || '');
    }

    return url == null ? void 0 : url.match(matcher);
  }

  function applyRules(response) {
    var _AxiosConfig$rules = AxiosConfig.rules,
        rules = _AxiosConfig$rules === void 0 ? [] : _AxiosConfig$rules;

    if (!(rules != null && rules.length)) {
      return false;
    }

    var config = response.config,
        data = response.data;
    return rules.some(function (rule) {
      var matcher = rule.matcher,
          message = rule.message,
          checkSuccess = rule.checkSuccess;

      if (isMatchUrl(matcher, config.url)) {
        if (checkSuccess(data)) {
          return true;
        }

        var msg = message(data);
        msg && axiosToast(msg);
        return true;
      }

      return false;
    });
  }

  var defaultResponseInterceptor = function defaultResponseInterceptor(response) {
    // 如果隐藏toast，则直接return
    if (response.config.hideToast) {
      return;
    }

    var _response$data = response.data,
        _response$data$succes = _response$data.success,
        success = _response$data$succes === void 0 ? true : _response$data$succes,
        _response$data$code = _response$data.code,
        code = _response$data$code === void 0 ? '' : _response$data$code,
        msg = _response$data.msg;

    if (applyRules(response)) {
      return;
    }

    var mapCode = codeMap[code]; // 新的错误处理方式为，只要后端不报错，都返回true
    // 前端进行提示以及操作

    if (success) {
      // 如果在errorCode中定义了code，则直接进行提示
      if (mapCode) {
        axiosToast(mapCode);
      }
    } else {
      // const mapCode: string = ErrorCode[code]
      // 兼容老的错误提示方式，保留此段代码
      // 老的错误处理方式为后端返回false，并且返回code，前端进行错误提示
      if (code) {
        var codeMsg = mapCode || msg;
        axiosToast(codeMsg);
      } else {
        axiosToast(msg);
      }
    }
  };

  var showToast = null;

  function debounce(func, delay) {
    var lastTime = 0;
    return function () {
      var now = Date.now();

      if (now - lastTime > delay) {
        lastTime = now;

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        func(args);
        return;
      }

      lastTime = now;
    };
  }

  var axiosToast = function axiosToast(message, hideToast) {
    if (hideToast === void 0) {
      hideToast = false;
    }

    if (hideToast) return;
    var toastDebounce = AxiosConfig.toastDebounce;

    if (typeof toastDebounce === 'object' && toastDebounce.toastDelay) {
      var toastDelay = toastDebounce.toastDelay;

      if (!showToast) {
        showToast = debounce(function () {
          queueExecutor(ToastInterceptorsList, message);
        }, toastDelay);
      }

      showToast();
      return;
    }

    queueExecutor(ToastInterceptorsList, message);
  };

  var interceptorsRequest = insertInterceptorsFactory(RequestInterceptorsList);
  var interceptorsResponse = insertInterceptorsFactory(ResponseInterceptorsList);
  var interceptorsToast = insertInterceptorsFactory(ToastInterceptorsList, function (toast) {
    return function (message) {
      if (message) {
        toast.error(message);
      }
    };
  });

  var initAxios = function initAxios(inst) {
    inst.interceptors.request.use(function (config) {
      queueExecutor(RequestInterceptorsList, config);
      return config;
    });
    inst.interceptors.response.use(function (config) {
      // 2xx 开头的处理
      if (!queueExecutor(ResponseInterceptorsList, config)) {
        defaultResponseInterceptor(config);
      }

      return config;
    }, function (error) {
      // 非 2xx
      var response = error.response || {};

      if (!queueExecutor(ResponseInterceptorsList, response)) {
        defaultResponseInterceptor(response);
      }

      return Promise.reject(error);
    });
  };

  initAxios(inst);
  return {
    axiosToast: axiosToast,
    interceptorsRequest: interceptorsRequest,
    interceptorsResponse: interceptorsResponse,
    interceptorsToast: interceptorsToast
  };
}

function useIQueryConfig() {
  /**默认toast防抖配置 */
  var ToastConfig = {
    toastDelay: 0
  };
  var AxiosConfig = {
    toastDebounce: ToastConfig
  };

  function setToastConfig(config) {
    AxiosConfig.toastDebounce = config;
  }

  function setActiveRule(rules) {
    AxiosConfig.rules = rules;
  }

  return {
    setToastConfig: setToastConfig,
    setActiveRule: setActiveRule,
    AxiosConfig: AxiosConfig
  };
}

var _excluded = ["method", "url", "data", "form", "query", "header", "extra", "unifiedDomainName", "optionName", "hideToast"],
    _excluded2 = ["abort"],
    _excluded3 = ["withCredentials", "rules", "hostConfig", "errorMap", "toastDebounce"],
    _excluded4 = ["application_name", "service_name", "method_name", "protobuf_version", "res_type_name"];

function useIQuerySdk(config) {
  var axiosInstance;
  var RequestQueue = [];
  var axiosConfig = useIQueryConfig();

  var _useErrorCode = useErrorCode(),
      injectErrorCode = _useErrorCode.injectErrorCode,
      httpCode = _useErrorCode.httpCode,
      errorCode = _useErrorCode.errorCode;

  var setActiveRule = axiosConfig.setActiveRule,
      setToastConfig = axiosConfig.setToastConfig;

  var _useHostConfig = useHostConfig(),
      getHostByName = _useHostConfig.getHostByName,
      injectHostConfig = _useHostConfig.injectHostConfig;

  var pushRequestQueue = function pushRequestQueue(request) {
    RequestQueue.push(request);
    request["finally"](function () {
      var index = RequestQueue.indexOf(request);
      RequestQueue.splice(index, 1);
    });
  };

  function onStatusError(error, hideToast) {
    var _error$response, _error$response2, _error$response3, _data$data;

    if (hideToast === void 0) {
      hideToast = false;
    }

    var err = error.response ? {
      code: (_error$response = error.response) == null ? void 0 : _error$response.status,
      message: (_error$response2 = error.response) == null ? void 0 : _error$response2.data.msg
    } : navigator.onLine ? {
      code: 10001,
      message: error.message
    } : {
      code: 10002,
      message: '网络错误，请检查网络是否正常！'
    };

    if (error.message !== cancelCode) {
      if (httpCode[err.code]) axiosToast(httpCode[err.code], hideToast);
    } // 返回详细的错误信息


    var data = _extends({}, (_error$response3 = error.response) == null ? void 0 : _error$response3.data);

    data.data = (_data$data = data.data) != null ? _data$data : {};
    return data;
  }

  var createRequest = function createRequest(_ref) {
    var method = _ref.method,
        url = _ref.url,
        data = _ref.data,
        form = _ref.form,
        query = _ref.query,
        header = _ref.header,
        _ref$extra = _ref.extra,
        extra = _ref$extra === void 0 ? {} : _ref$extra,
        unifiedDomainName = _ref.unifiedDomainName,
        optionName = _ref.optionName,
        hideToast = _ref.hideToast,
        others = _objectWithoutPropertiesLoose(_ref, _excluded);

    var config = _extends({}, others, extra, {
      hideToast: hideToast,
      method: method.toLocaleLowerCase(),
      headers: _extends({}, header, {
        'X-Alt-Referer': encodeURI(window.location.href),
        'X-Bff-End-Id': (CookieStorage == null ? void 0 : CookieStorage.getCookie('bffEndId')) || ''
      })
    }); // 如果设置了baseURL则不进行覆盖


    if (unifiedDomainName && !config.baseURL) {
      var baseURL = getHostByName(unifiedDomainName);

      if (baseURL) {
        config.baseURL = baseURL;
      }
    } // json


    if (data) {
      config = _extends({}, config, {
        headers: _extends({
          'Content-Type': 'application/json'
        }, config.headers),
        data: data
      });
    } // form


    if (form) {
      if (config.headers['Content-Type'] === 'multipart/form-data') {
        var formData = new FormData();

        for (var key in form) {
          formData.append(key, form[key]);
        }

        form = formData;
      } else {
        form = qs.stringify(form);
      }

      config = _extends({}, config, {
        headers: _extends({
          'Content-Type': 'application/x-www-form-urlencoded'
        }, config.headers),
        data: form
      });
    }

    if (optionName) {
      Object.assign(config.headers, {
        'option-name': optionName
      });
    }

    return new AjaxPromise(function (cancel, resolve, reject) {
      if (!axiosInstance) {
        reject('请求时初始化');
        return;
      }

      axiosInstance.request(_extends({}, config, {
        url: url,
        params: query,
        cancelToken: new CancelToken(cancel)
      })).then(function (res) {
        // 处理后端返回 data 为 null 的情况，将 data 初始化为 {}，提高业务容错率
        // res.data.data = res.data.data ?? {};
        // 兼容arraybuffer
        if (config.responseType === 'arraybuffer') {
          return resolve(res);
        }

        return resolve(res.data);
      }) // .then(resolve)
      ["catch"](function (err) {
        // 报错依然走resolve的逻辑
        return resolve(onStatusError(err, config.hideToast));
      });
    });
  };

  var request = function request(params) {
    var _ref2 = params.extra || {},
        _ref2$abort = _ref2.abort,
        abort = _ref2$abort === void 0 ? true : _ref2$abort,
        extra = _objectWithoutPropertiesLoose(_ref2, _excluded2);

    var request = createRequest(_extends({}, params, {
      extra: extra
    }));

    if (abort) {
      pushRequestQueue(request);
    }

    return request;
  };

  var createAxios = function createAxios(config) {
    var _ref3 = config || {},
        _ref3$rules = _ref3.rules,
        rules = _ref3$rules === void 0 ? [] : _ref3$rules,
        hostConfig = _ref3.hostConfig,
        errorMap = _ref3.errorMap,
        toastDebounce = _ref3.toastDebounce,
        other = _objectWithoutPropertiesLoose(_ref3, _excluded3);

    if (hostConfig) {
      // 允许外部设置host config
      injectHostConfig(hostConfig);
    }

    if (errorMap) {
      injectErrorCode(errorMap);
    } // set rules


    setActiveRule(rules);

    if (toastDebounce) {
      setToastConfig(toastDebounce);
    }

    return axios.create(_extends({
      withCredentials: true,
      headers: {}
    }, other || {}));
  };

  var abort = function abort() {
    var request;

    while (request = RequestQueue.shift()) {
      request.abort();
    }
  }; // mockConfig 由项目执行命令生成


  var mockConfig = {};

  if (process.env.NODE_ENV === 'development') {
    mockConfig = require('./mock/mockConfig.json');
  }
  /** webGateway 请求方式 */


  function webGateway(config) {
    var _config$optionName = config.optionName,
        optionName = _config$optionName === void 0 ? '' : _config$optionName,
        _config$params = config.params,
        params = _config$params === void 0 ? {} : _config$params,
        _config$extra = config.extra,
        extra = _config$extra === void 0 ? {} : _config$extra;

    var application_name = extra.application_name,
        service_name = extra.service_name,
        method_name = extra.method_name,
        protobuf_version = extra.protobuf_version,
        res_type_name = extra.res_type_name,
        otherExtra = _objectWithoutPropertiesLoose(extra, _excluded4);

    var temp = params;
    var host = getWebGatewayHost();

    if (!host) {
      console.error('未找到 webGateway 请求域名');
      return;
    } // let url = `${host}/webgateway/go?optionName=${optionName}`;


    var url = "/webgateway/go?optionName=" + optionName;
    var mockUrl = getMockUrl(optionName, mockConfig || {});

    if (mockUrl) {
      url = mockUrl;
      temp = _extends({}, temp, {
        mockExtra: {
          application_name: application_name,
          service_name: service_name,
          method_name: method_name,
          protobuf_version: protobuf_version,
          res_type_name: res_type_name
        }
      });
    }

    return request(_extends({
      method: 'POST',
      url: url,
      data: temp,
      optionName: optionName,
      baseURL: host
    }, otherExtra));
  }

  var ajax = function ajax(params) {
    return request(params);
  };

  function useIQuery() {
    return axiosInstance;
  }

  axiosInstance = createAxios(config);
  var methods = useInterceptors(axiosInstance, axiosConfig, errorCode);
  var axiosToast = methods.axiosToast;
  return _extends({}, methods, {
    ajax: ajax,
    request: request,
    webGateway: webGateway,
    abort: abort,
    useIQuery: useIQuery
  });
}

var _excluded$1 = ["method", "url", "data", "form", "query", "header", "extra", "unifiedDomainName", "optionName", "hideToast"],
    _excluded2$1 = ["abort"],
    _excluded3$1 = ["withCredentials", "rules", "hostConfig", "errorMap", "toastDebounce"],
    _excluded4$1 = ["application_name", "service_name", "method_name", "protobuf_version", "res_type_name"];

var setActiveRule$1 = Config.setActiveRule,
    setToastConfig$1 = Config.setToastConfig;
var RequestQueue = [];

var pushRequestQueue = function pushRequestQueue(request) {
  RequestQueue.push(request);
  request["finally"](function () {
    var index = RequestQueue.indexOf(request);
    RequestQueue.splice(index, 1);
  });
};

function onStatusError(error, hideToast) {
  var _error$response, _error$response2, _error$response3, _data$data;

  if (hideToast === void 0) {
    hideToast = false;
  }

  var err = error.response ? {
    code: (_error$response = error.response) == null ? void 0 : _error$response.status,
    message: (_error$response2 = error.response) == null ? void 0 : _error$response2.data.msg
  } : navigator.onLine ? {
    code: 10001,
    message: error.message
  } : {
    code: 10002,
    message: '网络错误，请检查网络是否正常！'
  };

  if (error.message !== cancelCode) {
    if (HttpCode[err.code]) axiosToast(HttpCode[err.code], hideToast);
  } // 返回详细的错误信息


  var data = _extends({}, (_error$response3 = error.response) == null ? void 0 : _error$response3.data);

  data.data = (_data$data = data.data) != null ? _data$data : {};
  return data;
}

var inst;

var createRequest = function createRequest(_ref) {
  var method = _ref.method,
      url = _ref.url,
      data = _ref.data,
      form = _ref.form,
      query = _ref.query,
      header = _ref.header,
      _ref$extra = _ref.extra,
      extra = _ref$extra === void 0 ? {} : _ref$extra,
      unifiedDomainName = _ref.unifiedDomainName,
      optionName = _ref.optionName,
      hideToast = _ref.hideToast,
      others = _objectWithoutPropertiesLoose(_ref, _excluded$1);

  var config = _extends({}, others, extra, {
    hideToast: hideToast,
    method: method.toLocaleLowerCase(),
    headers: _extends({}, header, {
      'X-Alt-Referer': encodeURI(window.location.href),
      'X-Bff-End-Id': (CookieStorage == null ? void 0 : CookieStorage.getCookie('bffEndId')) || ''
    })
  }); // 如果设置了baseURL则不进行覆盖


  if (unifiedDomainName && !config.baseURL) {
    var baseURL = getHost(unifiedDomainName);

    if (baseURL) {
      config.baseURL = baseURL;
    }
  } // json


  if (data) {
    config = _extends({}, config, {
      headers: _extends({
        'Content-Type': 'application/json'
      }, config.headers),
      data: data
    });
  } // form


  if (form) {
    if (config.headers['Content-Type'] === 'multipart/form-data') {
      var formData = new FormData();

      for (var key in form) {
        formData.append(key, form[key]);
      }

      form = formData;
    } else {
      form = qs.stringify(form);
    }

    config = _extends({}, config, {
      headers: _extends({
        'Content-Type': 'application/x-www-form-urlencoded'
      }, config.headers),
      data: form
    });
  }

  if (optionName) {
    Object.assign(config.headers, {
      'option-name': optionName
    });
  }

  return new AjaxPromise(function (cancel, resolve, reject) {
    if (!inst) {
      reject('请求时初始化');
      return;
    }

    inst.request(_extends({}, config, {
      url: url,
      params: query,
      cancelToken: new CancelToken(cancel)
    })).then(function (res) {
      // 处理后端返回 data 为 null 的情况，将 data 初始化为 {}，提高业务容错率
      // res.data.data = res.data.data ?? {};
      // 兼容arraybuffer
      if (config.responseType === 'arraybuffer') {
        return resolve(res);
      }

      return resolve(res.data);
    }) // .then(resolve)
    ["catch"](function (err) {
      // 报错依然走resolve的逻辑
      return resolve(onStatusError(err, config.hideToast));
    });
  });
};

var request = function request(params) {
  var _ref2 = params.extra || {},
      _ref2$abort = _ref2.abort,
      abort = _ref2$abort === void 0 ? true : _ref2$abort,
      extra = _objectWithoutPropertiesLoose(_ref2, _excluded2$1);

  var request = createRequest(_extends({}, params, {
    extra: extra
  }));

  if (abort) {
    pushRequestQueue(request);
  }

  return request;
};

var abort = function abort() {
  var request;

  while (request = RequestQueue.shift()) {
    request.abort();
  }
};

var createAxios = function createAxios(config) {
  var _ref3 = config || {},
      _ref3$rules = _ref3.rules,
      rules = _ref3$rules === void 0 ? [] : _ref3$rules,
      hostConfig = _ref3.hostConfig,
      errorMap = _ref3.errorMap,
      toastDebounce = _ref3.toastDebounce,
      other = _objectWithoutPropertiesLoose(_ref3, _excluded3$1);

  if (hostConfig) {
    // 允许外部设置host config
    setHostConfig(hostConfig);
  }

  if (errorMap) {
    injectErrorCode(errorMap);
  }

  inst = axios.create(_extends({
    withCredentials: true,
    headers: {}
  }, other || {})); // set rules

  setActiveRule$1(rules);

  if (toastDebounce) {
    setToastConfig$1(toastDebounce);
  }

  initAxios(inst);
  return {
    request: request,
    webGateway: webGateway,
    abort: abort,
    ajax: ajax,
    axiosInstance: inst
  };
}; // mockConfig 由项目执行命令生成


var mockConfig = {};

if (process.env.NODE_ENV === 'development') {
  mockConfig = /*#__PURE__*/require('./mock/mockConfig.json');
}
/** webGateway 请求方式 */


function webGateway(config) {
  var _config$optionName = config.optionName,
      optionName = _config$optionName === void 0 ? '' : _config$optionName,
      _config$params = config.params,
      params = _config$params === void 0 ? {} : _config$params,
      _config$extra = config.extra,
      extra = _config$extra === void 0 ? {} : _config$extra;

  var application_name = extra.application_name,
      service_name = extra.service_name,
      method_name = extra.method_name,
      protobuf_version = extra.protobuf_version,
      res_type_name = extra.res_type_name,
      otherExtra = _objectWithoutPropertiesLoose(extra, _excluded4$1);

  var temp = params;
  var host = getWebGatewayHost();

  if (!host) {
    console.error('未找到 webGateway 请求域名');
    return;
  } // let url = `${host}/webgateway/go?optionName=${optionName}`;


  var url = "/webgateway/go?optionName=" + optionName;
  var mockUrl = getMockUrl(optionName, mockConfig || {});

  if (mockUrl) {
    url = mockUrl;
    temp = _extends({}, temp, {
      mockExtra: {
        application_name: application_name,
        service_name: service_name,
        method_name: method_name,
        protobuf_version: protobuf_version,
        res_type_name: res_type_name
      }
    });
  }

  return request(_extends({
    method: 'POST',
    url: url,
    data: temp,
    optionName: optionName,
    baseURL: host
  }, otherExtra));
}

var ajax = function ajax(params) {
  return request(params);
};

export default createAxios;
export { AjaxPromise, axiosToast, createAxios, interceptorsRequest, interceptorsResponse, interceptorsToast, useIQuerySdk, webGateway };
//# sourceMappingURL=iquery.esm.js.map
